// extracted by mini-css-extract-plugin
export default {"container":"Search_container__dC7v6","search":"Search_search__bdT6T","transparent":"Search_transparent__N3xCs"};